// Get Inventory Movements Use Case

import {InventoryRepository} from '../repository/InventoryRepository';
import {InventoryMovement, InventoryMovementFilters} from '../models/inventory.model';
import {Pagination} from '../../../Data/types/BaseResponse';

export class GetInventoryMovementsUseCase {
  constructor (private inventoryRepository: InventoryRepository) {}

  async execute (filters?: InventoryMovementFilters, page = 1, limit = 20): Promise<{ items: InventoryMovement[]; pagination?: Pagination }> {
    try {

      const result = await this.inventoryRepository.getInventoryMovements(filters, page, limit);

      // Business Logic: Sort by most recent first
      const sortedItems = result.items.sort((a, b) =>
        new Date(b.performedAt).getTime() - new Date(a.performedAt).getTime()
      );

      return {
        items: sortedItems,
        pagination: result.pagination
      };
    } catch (error) {
      throw error;
    }
  }
}
